import { useMemo } from "react";
import { RadioButtonGroup } from "@bonliva-crm/ui";
import locale from "@bonliva-crm/locale";
import { QualityCheckFilterItemFragment } from "@bonliva-crm/graphql";

type QualityCheckNameSelectorProps = {
  value: string | null;
  onChange: (value: string) => void;
  items: QualityCheckFilterItemFragment[];
};

export function QualityCheckNameSelector(props: QualityCheckNameSelectorProps) {
  const options = useMemo(() => {
    return (
      props.items?.map(({ name }) => ({
        label: locale.searchQualityCheckName[name] || name,
        value: name
      })) || []
    );
  }, [props.items]);

  return (
    <RadioButtonGroup
      label={locale.selectQCDocument}
      value={props.value ?? ""}
      options={options}
      onChange={(event, value) => props.onChange(value)}
    />
  );
}
